<div class="not-found-wrapper">
  <div class="not-found-contents">
    <img loading="lazy" src="assets/404.png">
    <h4>Oops, Page Not Found!</h4>
    <button class="btn btn-primary mt-3" (click)="coreService.goHome()">Return Home</button>
  </div>
</div>